import React from 'react';

type Status = 'backlog' | 'in-progress' | 'in-review' | 'done' | 'blocked';

interface StatusBadgeProps {
  status: Status;
}

const statusConfig: Record<Status, { label: string; className: string }> = {
  backlog: {
    label: 'Backlog',
    className: 'bg-gray-100 text-gray-600 border-gray-200',
  },
  'in-progress': {
    label: 'In Progress',
    className: 'bg-blue-50 text-blue-700 border-blue-200',
  },
  'in-review': {
    label: 'In Review',
    className: 'bg-violet-50 text-violet-700 border-violet-200',
  },
  done: {
    label: 'Done',
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  blocked: {
    label: 'Blocked',
    className: 'bg-red-50 text-red-700 border-red-200',
  },
};

export default function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status];
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold border whitespace-nowrap ${config.className}`}
    >
      <span
        className={`h-1.5 w-1.5 rounded-full inline-block ${
          status === 'in-progress' ?'bg-blue-500 animate-pulse'
            : status === 'blocked' ?'bg-red-500'
            : status === 'done' ?'bg-emerald-500'
            : status === 'in-review' ?'bg-violet-500' :'bg-gray-400'
        }`}
      />
      {config.label}
    </span>
  );
}